import styled, { css, DefaultTheme } from 'styled-components';
import { Tooltip as AntdTooltip } from 'antd';

type TdProps = {
  isTotal?: boolean;
};

export const DebitValue = styled.p`
  ${({ theme }) => css`
    font-weight: 600;
    font-size: 1.6rem;
    line-height: 2.4rem;

    color: ${theme.colors.neutralGray70};

    margin-bottom: 16px;

    span {
      color: ${theme.colors.statusSuccess30};
    }
  `}
`;

export const Fee = styled.p`
  ${({ theme }) => css`
    font-weight: 400;
    font-size: 1.6rem;
    line-height: 2.4rem;

    margin: 8px 0 16px 0;

    color: ${theme.colors.neutralGray50};
  `}
`;

export const Table = styled.table`
  width: 100%;
`;

export const TableTitle = styled.div`
  ${({ theme }) => css`
    color: ${theme.colors.neutralGray40};

    gap: 8px;
    display: flex;
    align-items: center;

    p {
      font-weight: 500;
      font-size: 1.2rem;
      line-height: 2rem;

      text-transform: uppercase;
    }
  `}
`;

const tdModifiers = {
  total: (theme: DefaultTheme) => css`
    color: ${theme.colors.statusSuccess30};
    font-weight: 500;
  `,
};

export const Td = styled.td<TdProps>`
  ${({ theme, isTotal }) => css`
    font-weight: 400;
    font-size: 1.4rem;
    line-height: 2.2rem;

    padding: 16px 0;

    color: ${theme.colors.neutralGray50};

    &:nth-child(even) {
      color: ${theme.colors.neutralGray80};
      text-align: right;

      ${isTotal && tdModifiers.total(theme)}
    }
  `}
`;

export const Tooltip = styled(AntdTooltip)`
  margin-left: 8px;
`;
